import React from 'react';
import { useNavigate } from 'react-router-dom';


const OrgAccountReview = () => {
    const navigate = useNavigate()
  return (
    <div className="min-h-screen w-full bg-white flex flex-col">
      <div className="w-full border-b border-[#0B214E33] py-6 px-6">
        <img src="/fx_logo_old.png" alt="FXMaster Logo" className="w-[160px]" />
        <button
          onClick={() => navigate('/login')}
          className="bg-[#0B214E] w-[280px] text-[#DEE9FC] py-3 px-8 rounded-lg"
        >
          Go to Login
        </button>
      </div>
      <div className="flex flex-1 items-center justify-center px-4">
        <div className="text-center">
          <h1 className="text-5xl font-semibold text-[#E9620B]">
            Your account is under <br />
            review.
          </h1>
        </div>
      </div>
    </div>
  );
};

export default OrgAccountReview;
